import { LitElement, html } from 'lit';
import '../../../shared/components/select/Select';
import '../../../shared/components/icons/IconArrowRight';
import styles from './styles';

class JobBoardListing extends LitElement {
  static styles = styles;

  static properties = {
    jobs: {
      type: Array,
      state: true,
    },
    sortBy: {
      type: String,
    },
  };

  constructor() {
    super();
    this.jobs = [];
    this.sortBy = 'title';
  }

  #selectHandler(e) {
    const { value } = e?.detail;

    if (value && this.sortBy !== value) {
      this.sortBy = value;
      this.#sort(this.sortBy);
    }
  }

  connectedCallback() {
    super.connectedCallback();
  }

  #sort(key) {
    const sortArr = Array.from(this.jobs);

    function compare(a, b) {
      const aValue = key.split('.').reduce((p, c) => p?.[c], a);
      const aFormatted = (Array.isArray(aValue) ? aValue.join(', ') : aValue).toLowerCase();

      const bValue = key.split('.').reduce((p, c) => p?.[c], b);
      const bFormatted = (Array.isArray(bValue) ? bValue.join(', ') : bValue).toLowerCase();
      if (aFormatted > bFormatted) {
        return 1;
      } if (aFormatted < bFormatted) {
        return -1;
      }
      return 0;
    }

    sortArr.sort(compare);
    this.jobs = sortArr;
    this.requestUpdate('data');
  }

  firstUpdated() {
    if (this.sortBy) {
      this.#sort(this.sortBy);
    }
  }

  render() {
    const options = [
      {
        label: 'Title',
        value: 'title',
      },
      {
        label: 'Category',
        value: 'category.value',
      },
      {
        label: 'Location',
        value: 'location.value',
      },
    ];

    return html`
      <div class="sort-by">
        Sort By:
        <tenable-select
          class="job-board-listing-select"
          name="sort-by"
          @input-change=${(e) => this.#selectHandler(e)}
          .options=${options}
        >
        </tenable-select>
      </div>

      ${this.jobs.length <= 0 ? html`
        <p class="mt-3">No jobs found matching your filter</p>
      ` : html`
        <div class="job-board-listing">
          ${this.jobs.map((job) => html`
            <div class="job-board-card py-3">
              <em>${job.category.value}</em><br />
              <a target="_blank" rel="noreferrer" href="${job.url}">${job.title}</a><br />
              <span>${job.location.value.join(', ')}</span>
            </div>
          `)}
        </div>
      `}
    `;
  }
}

customElements.define('tenable-job-board-listing', JobBoardListing);
